import s from './ProgressBar.scss'
import { UncontrolledTooltip } from 'reactstrap'

const ProgressBar = ({
  regularHours,
  offHours,
  maxValue,
  index,
  secondShiftBillableHours,
  thirdShiftBillableHours,
  overtimeBillableHours,
  secondShiftNotBillableHours,
  thirdShiftNotBillableHours,
  overtimeNotBillableHours,
  standardBillableHours,
  standardNotBillableHours,
  withTooltip = true
}) => {
  const regularWidth = (regularHours / maxValue) * 100
  const offWidth = (offHours / maxValue) * 100

  return (
    <div
      className={s.progressBar}
      style={offHours && regularHours ? {} : { backgroundColor: 'transparent' }}
    >
      {regularHours ? (
        <>
          <div
            className={s.progressRegular}
            style={{
              width: `${regularWidth}%`,
              ...(regularHours ? {} : { backgroundColor: 'transparent' })
            }}
            id={`regular${index ? index : ''}`}
          />
          {withTooltip && (
            <UncontrolledTooltip placement="top" target={`regular${index ? index : ''}`}>
              <p>Billable: {regularHours}h</p>
              <div>
                <span style={{ display: 'block' }}>Standard: {standardBillableHours}h</span>
                <span style={{ display: 'block' }}>Second Shift: {secondShiftBillableHours}h</span>
                <span style={{ display: 'block' }}>Third Shift: {thirdShiftBillableHours}h</span>
                <span style={{ display: 'block' }}>Overtime: {overtimeBillableHours}h</span>
              </div>
            </UncontrolledTooltip>
          )}
        </>
      ) : null}
      {offHours ? (
        <>
          <div
            id={`off${index ? index : ''}`}
            className={s.progressOff}
            style={{ width: `${offWidth}%` }}
          />
          {withTooltip && (
            <UncontrolledTooltip placement="top" target={`off${index ? index : ''}`}>
              <p>Not Billable: {offHours}h</p>
              <div>
                <span style={{ display: 'block' }}>Standard: {standardNotBillableHours}h</span>
                <span style={{ display: 'block' }}>
                  Second Shift: {secondShiftNotBillableHours}h
                </span>
                <span style={{ display: 'block' }}>Third Shift: {thirdShiftNotBillableHours}h</span>
                <span style={{ display: 'block' }}>Overtime: {overtimeNotBillableHours}h</span>
              </div>
            </UncontrolledTooltip>
          )}
        </>
      ) : null}
    </div>
  )
}

export default ProgressBar
